import Layout from '../components/layout';
import { SiteShellContent } from '../components/SiteShell';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useGetReservationQuery } from '../services/bookingApi';

export default function Index() {
  const { query, replace, locale } = useRouter();
  const bookingId = query.bookingId;

  const { data: reservation } = useGetReservationQuery(bookingId as string, {
    skip: !bookingId?.length,
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (!reservation?.objectId) return;

    replace(`/confirmation?bookingId=${reservation?.objectId}`);
  }, [reservation?.objectId, reservation?.venueId]);

  // The root has no restaurant to book. It used to render an empty layout,
  // so a guest (or scanner) arriving at reservation.<domain> was redirected
  // to /<locale> and saw only the background. It now says who we are and
  // links to the country site's booking page.
  return (
    <Layout>
      <SiteShellContent locale={locale} landing />
    </Layout>
  );
}
